const description = 'fantasy.rules.desc' as const;

const generalRules = [
  'fantasy.rules.general_rule.0',
  'fantasy.rules.general_rule.1',
  'fantasy.rules.general_rule.2',
  'fantasy.rules.general_rule.3',
  'fantasy.rules.general_rule.4',
  'fantasy.rules.general_rule.5',
] as const;

const prizeDistributionRules = [
  'fantasy.rules.prize_distribution.0',
  'fantasy.rules.prize_distribution.1',
  'fantasy.rules.prize_distribution.2',
  'fantasy.rules.prize_distribution.3',
  'fantasy.rules.prize_distribution.4',
  'fantasy.rules.prize_distribution.5',
] as const;

const scoreUpdateAndCompetitionClosingRules = [
  'fantasy.rules.score_update_and_competition_closing.0',
  'fantasy.rules.score_update_and_competition_closing.1',
] as const;

const rankingAndPointsCalcRule = 'fantasy.rules.ranking_and_points_calculations' as const;

const scoringSystem = {
  positive: {
    heading: 'fantasy.rules.positive',
    rules: [
      {
        rule: 'fantasy.rules.scoring.play_upto_60',
        points: 1,
      },
      {
        rule: 'fantasy.rules.scoring.play_60_or_more',
        points: 2,
      },
      {
        rule: 'fantasy.rules.scoring.goal_by_keeper_or_def',
        points: 6,
      },
      {
        rule: 'fantasy.rules.scoring.goal_by_mid',
        points: 5,
      },
      {
        rule: 'fantasy.rules.scoring.goal_by_forward',
        points: 4,
      },
      {
        rule: 'fantasy.rules.scoring.goal_assist',
        points: 3,
      },
      {
        rule: 'fantasy.rules.scoring.clean_sheet_by_keeper_or_defender',
        points: 4,
      },
      {
        rule: 'fantasy.rules.scoring.clean_sheet_by_mid',
        points: 1,
      },
      {
        rule: 'fantasy.rules.scoring.penalty_save',
        points: 5,
      },
      {
        rule: 'fantasy.rules.scoring.successful_pass',
        points: 0.02,
      },
    ],
  },
  negative: {
    heading: 'fantasy.rules.negative',
    rules: [
      {
        rule: 'fantasy.rules.scoring.penalty_miss',
        points: -2,
      },
      {
        rule: 'fantasy.rules.scoring.yellow_card',
        points: -1,
      },
      {
        rule: 'fantasy.rules.scoring.red_card',
        points: -3,
      },
      {
        rule: 'fantasy.rules.scoring.own_goal',
        points: -2,
      },
    ],
  },
} as const;

export const fantasyRules = {
  description,
  sections: [
    {
      heading: 'fantasy.rules.general_rules',
      rules: generalRules,
    },
    {heading: 'fantasy.rules.prize_distribution', rules: prizeDistributionRules},
    {
      heading: 'fantasy.rules.score_update_and_competition_closing_heading',
      rules: scoreUpdateAndCompetitionClosingRules,
    },
    {
      heading: 'fantasy.rules.ranking_and_points_calc',
      rules: rankingAndPointsCalcRule,
    },
  ],
  scoringSystem: {
    heading: 'fantasy.rules.scoring_system',
    scoring: scoringSystem,
  },
} as const;
